import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=0a0a0fd9&scoped=true&"
import script from "./Radio.vue?vue&type=script&lang=ts&"
export * from "./Radio.vue?vue&type=script&lang=ts&"
import style0 from "./Radio.vue?vue&type=style&index=0&id=0a0a0fd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0a0fd9",
  null
  
)

export default component.exports